import React from 'react';

import { useStyles } from './NoClips.styles';
import { Button, Image, Typography } from 'shared/components';
import { useLocale } from 'shared/hooks/useLocale/useLocale';
import { ParticipantSelectionFooter } from 'app/participantSelection/footer/ParticipantSelectionFooter';
import { StudentLoginHeader } from 'app/studentLoginPage/studentLoginHeader/studentLoginHeader';
import uploadIcon from 'assets/sorry.svg';

export const NoClips = () => {
  const styles = useStyles();
  const { formatMessage } = useLocale();

  const openContactSupport = () => {
    const supportURL = 'https://stageclip.com/student-support/';
    window.open(supportURL, '_blank');
  };

  return (
    <div>
      <StudentLoginHeader />
      <div style={{ marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Image src={uploadIcon} alt="404" className={styles.image} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <>
            <Typography className={styles.rootText}>
              {formatMessage({ id: 'studentSelection.not.found.header' })}
            </Typography>
            <Typography className={styles.subHeader}>
              {formatMessage({ id: 'studentSelection.not.found.sub_header' })}
            </Typography>
          </>
          <div>
            <Button className={styles.confirmButton} onClick={() => openContactSupport()}>
              Contact
            </Button>
          </div>
        </div>
      </div>
      <ParticipantSelectionFooter />
    </div>
  );
};
